import { StyleSheet } from 'react-native';

import { withTypography } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

export const LoadingText = withTypography({
  bold: true,
  textAlign: 'center',
  fontSize: 'md',
  lineHeight: 'md',
  style: {
    margin: 0,
  },
});

export const ModalTitle = withTypography({
  variant: 'headerTwo',
  textAlign: 'center',
});

export const AddressInfoLine = withTypography({
  variant: 'headerThree',
  style: {
    margin: 0,
    marginBottom: spacing.$1,
    marginTop: spacing.$5,
  },
});

export const AliasOptions = withTypography({
  variant: 'headerFour',
  style: {
    includeFontPadding: false,
    margin: 0,
    marginBottom: 0,
    textAlignVertical: 'center',
  },
});

export const AliasOptionText = withTypography({
  fontSize: 'sm',
  bold: true,
  color: primitive.$bbqBrown,
});

export const AliasOptionTextSelected = withTypography({
  fontSize: 'sm',
  bold: true,
  color: primitive.$white,
});

export const deliveryAddressFormHeaderStyles = StyleSheet.create({
  modalHeading: {
    paddingVertical: 16,
    paddingHorizontal: 12,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  side: {
    width: '20%',
    alignItems: 'flex-start',
  },
  center: {
    width: '60%',
    alignItems: 'center',
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    color: primitive.$bbqBrown,
    textAlign: 'center',
  },
});

export const DialogStyles = StyleSheet.create({
  headingContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  bodyContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
    paddingBottom: 16,
  },
});

export const lockInputStyle = StyleSheet.create({
  lockedContainer: {
    paddingVertical: 15,
    minHeight: 30,
    borderWidth: 1,
    borderColor: '#D1D5DB',
    borderRadius: 4,
    backgroundColor: '#F3F4F6',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
  },
  lockedText: {
    flex: 1,
    fontFamily: 'Flame-RegularSans',
    color: '#6B7280',
  },
  iconContainer: {
    marginLeft: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
